/*
*****************************************************************************
*File : chartlist.js
*Module : Dashboard Frontend
*Purpose : Vue-Chartlist
*Author : UI Team
*Copyright : Copyright 2021, Lab to Market Innovations Private Limited
*****************************************************************************
*/

import Vue from 'vue'
import 'chartist/dist/chartist.min.css'

Vue.use(require('vue-chartist'))
